import { defineComponent } from 'vue';

export const useFragment = defineComponent({
  inheritAttrs: false,
  render() {
    return this.$slots && (typeof this.$slots.default === 'function' ? this.$slots.default() : '');
  },
});
